import jackWordmark from "../assets/jack-wordmark-full.png";
import { useTheme } from "../context/ThemeContext";

const ASPECT = 3.37; // width / height of the ®-wordmark asset

export function Logo({ size = 32, light = false }) {
  const { theme } = useTheme();
  const color = light || theme === "dark" ? "#ffffff" : "#4B23CC";
  return (
    <div
      className="select-none shrink-0"
      role="img"
      aria-label="Jack Cash"
      style={{
        height: size,
        width: size * ASPECT,
        backgroundColor: color,
        WebkitMaskImage: `url(${jackWordmark})`,
        maskImage: `url(${jackWordmark})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
